import { createFileRoute } from '@tanstack/react-router';
import { AdminUsagePage } from '../../features/billing';

export const Route = createFileRoute('/admin/usage/')({ component: AdminUsagePage });
